<template lang="pug">
    .section
      section.services
        .services__body
          .services__list.grid
            template(
              v-for="category in categories"
            )
              h3.services-category__title(
                v-if="category.title"
              ) {{ category.title }}
              template(
                v-for='id in category.list'
              )
                Service(
                  :id='id'
                )
</template>

<script>
import { mapGetters } from "vuex";

import Service from "@/components/Service.vue";

export default {
  computed: {
    ...mapGetters({
      categories: "services/categories"
    })
  },
  components: {
    Service
  }
};
</script>

<style lang="scss">
.services {
  width: 596px;
  padding-top: 20px;

  &-category__title {
    color: white;
    grid-column-start: 1;
    grid-column-end: 3;
  }

  &__header {
  }

  &__title {
    color: $white;
    font-weight: $semibold;
    line-height: 1.23;
  }

  &__body {
    margin-top: 14px;
  }

  &__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px 20px;
    width: 100%;
  }

  &__item {
  }
}
</style>
